/* eslint class-methods-use-this: 0 */
import { extend } from 'lodash';
import CollectionModule from 'client/store/modules/CollectionModule';
import IpListsApi from 'client/api/v2/IpListsApi';
import Vue from 'vue';

export class IpListsCollectionClass extends CollectionModule {
  extractModule() {
    const module = super.extractModule();

    module.mutations.SET_ATTACHED_UNDELETED_ITEM_ID = (...params) => this
      .SET_ATTACHED_UNDELETED_ITEM_ID(...params);

    return module;
  }

  getInitialState() {
    const state = super.getInitialState();

    state.features.deletedItems.attachedIpListDeleteFailures = [];

    return state;
  }

  /**
   * This method exists to keep item prototype chains intact.
   *
   * When setting objects in "state...byId" the CollectionModule uses:
   * extend({}, originalObj, newObj)
   * That has the upside of making sure the object set in state has no
   * references to other objects. Therefore multiple values will not be
   * modified in multiple objects on accident.
   *
   * It has the downside of wiping away the prototype chain. If objects
   * of a specific type are being used in components and Vuex stores
   * there would be no way of finding the original constructor.
   *
   * This method extends the object while keeping the prototype chain so
   * type checking can continue.
   * @param  {} destination
   * @param  {} extension
   * @returns {} object with prototype chain intact
   */
  extendExistingObject(destination, extension = {}) {
    return extend(destination, extension);
  }

  setDeletedItemIds({ commit }, { deletedIds, failedTasks, attachedIpListDeleteFailures }) {
    commit('SET_DELETED_ITEM_IDS', deletedIds);
    commit('SET_UNDELETED_ITEM_ID', failedTasks);
    commit('SET_ATTACHED_UNDELETED_ITEM_ID', attachedIpListDeleteFailures);
  }

  SET_ATTACHED_UNDELETED_ITEM_ID(state, attachedIpListDeleteFailures) {
    Vue.set(state.features.deletedItems, 'attachedIpListDeleteFailures', attachedIpListDeleteFailures);
  }

  resetCollection({ commit }, { soft = false } = {}) {
    commit('RESET_COLLECTION', { soft });
    commit('SET_ATTACHED_UNDELETED_ITEM_ID', []);
  }
}

export default new IpListsCollectionClass(IpListsApi, 'id').extractModule();
